import { Category } from '../components/Category';
import { useCategory } from '../services/useCategory';

export const CategoryContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { is_hide, categories, onClickCategoryItem } = useCategory();

  if (is_hide) {
    return null;
  }

  return <Category categories={categories} onClickCategoryItem={onClickCategoryItem} />;
};
